<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('proyectos')">Proyecto:</inertia-link>
      <span class="text-indigo-400 font-medium"></span>
      {{ form.proyecto}}/Área {{ form.metraje}} m2, Mz. {{ form.manzana }}, Lote {{ form.lote }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.asesor" :error="form.errors.asesor" class="pr-6 pb-8 w-full lg:w-2/6" label="Asesor" required>
            <option v-for="asesor in asesores" :key="asesor.id" :value="asesor.id">{{ asesor.nombres }}  {{ asesor.apellidos }}</option>
          </select-input>
          <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-3/6" label="Cliente" required/>
          <select-input v-model="form.tipo" :error="form.errors.tipo" class="pr-6 pb-8 w-full lg:w-1/6" label="Proforma" required>
            <option>Contado</option>
            <option>Financiado</option>
          </select-input>
          <text-input v-if="form.tipo=='Financiado'"  v-model="form.entrada" :error="form.errors.entrada" class="pr-6 pb-8 w-full lg:w-1/6" label="Entrada"/>
          <text-input v-if="form.tipo=='Financiado'" v-model="form.plazo" :error="form.errors.plazo" class="pr-6 pb-8 w-full lg:w-1/6" label="Plazo" />
          <text-input v-model="form.descuento" :error="form.errors.descuento" class="pr-6 pb-8 w-full lg:w-1/6" label="% Descuento"/>
          <text-input v-model="form.valor" :error="form.errors.valor" class="pr-6 pb-8 w-full lg:w-1/6" label="Valor $"/>
          
         
           </div>
           <br>
           <label>---Valor final de contado con descuento del {{ form.descuento }}% es de {{ form.valor-(form.valor*(form.descuento/100))  }} $</label>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Imprimir</loading-button>
        </div>
        
      </form>
    </div>
   
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Pagination from '@/Shared/Pagination'

export default {
  metaInfo() {
    return {
      title: `${this.form.nombre}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    Pagination,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    organizations: Array,
    lotes: Array,
    asesores: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        proyecto: this.lotes[0]['Proyecto'],
        nombre: null,
        asesor: null,
        metraje: this.lotes[0]['TotalMetraje'],
        entrada: this.lotes[0]['AreaConstruccion'],
        manzana: this.lotes[0]['Manzana'],
        lote: this.lotes[0]['Lote'],
        valor: (this.lotes[0]['TotalMetraje']*this.lotes[0]['MetrosConstruccion']),
        valorfinal: 0,
        plazo: 120,
        descuento: 0,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('proyectos.storecotizar'))
    },
  },
}
</script>
